// Server authorization is authoritative; never infer ownership from company owner_name.
export function ownershipUserLabel(id: number | null, name?: string | null): string {
  return id == null ? 'Unassigned' : name?.trim() || `User #${id}`;
}

export function contactOwnerLabel(person: { owner_user_id: number | null; contact_owner_name: string | null }): string {
  return ownershipUserLabel(person.owner_user_id, person.contact_owner_name);
}

export function transferValidation(ownerId: number | undefined, verticalId: number, eligibleIds: number[], note: string, moveDeals: string): string {
  if (!Number.isInteger(verticalId) || verticalId <= 0) return 'Choose a destination pipeline.';
  if (!ownerId || !eligibleIds.includes(ownerId)) return 'Choose an eligible contact owner for this pipeline.';
  if (!note.trim()) return 'A handover note is required.';
  if (moveDeals !== 'yes' && moveDeals !== 'no') return 'Choose whether to move open deals.';
  return '';
}

export const handoverCacheKeys = [
  'people', 'person', 'person-detail', 'people-picker', 'ownership-history',
  'contact-history', 'person-activities', 'activities', 'deals', 'deal', 'deals-board', 'site-people',
  'site-activities', 'sites', 'dashboard', 'customer-care', 'my-day-action-activities',
  'my-day-action-leads', 'my-day-action-care', 'my-day-owned-contacts', 'my-day-owned-deals',
  'my-day-owned-lifecycle', 'my-day-unassigned-contacts', 'my-day-meetings', 'my-day-callbacks'
];
